let faqHandler = function faqHandler() {
    
    let faqButton = document.querySelectorAll(".faq-item__header");
  
    for (let i = 0; i < faqButton.length; i++) {
      faqButton[i].addEventListener("click", function (e) {
        let target = e.target;
        let targetButton = target.closest(".faq-item");
        let buttons = document.querySelectorAll(".faq-item");
  
        if (targetButton) {
          let faqItem = target.closest(".faq-item");
  
          if (faqItem.classList.contains("active")) {
            faqItem.classList.remove("active");
          } else {
            for (let j = 0; j < buttons.length; j++) {
              buttons[j].classList.remove("active");
            }
  
            faqItem.classList.add("active");
          }
        }
      });
    }
};

export default faqHandler;